import './author.scss';
import * as React from 'react';
import { Assets } from '../../content/assets';
import { LazyCosmosImage } from '../media/cosmosImage';
export const Author = ({ photo_url, alt_photo_url, name, position }) => {
    const mainImage = React.useMemo(() => {
        if (photo_url?.[0]) {
            return { ticket: photo_url[0].ticket };
        }
        if (alt_photo_url?.[0]) {
            return { ticket: alt_photo_url[0].ticket };
        }
        return { src: Assets.brand.logoMark };
    }, []);
    return (<div className="author">
      <LazyCosmosImage {...mainImage} alt={name}/>

      <div className="author-details">
        <p>
          <strong>{name || 'Rocketmakers'}</strong>
        </p>
        <p className="author-position">{position}</p>
      </div>
    </div>);
};
